import { BlockingMode, MaintenanceSlot, MaintenanceTimeSpan, ResourceMaintenanceSlot } from "../types/maintenance";
import { normalizeDayOfWeek, serializeDayOfWeek } from "@/utils/date";
import { api } from "./axios";

const baseUrl = '/rest/v1/resource-slots/maintenance'
const baseUrlWithResource = '/rest/v1/resource-slots/{resourceId}/maintenance'

function mapMaintenanceSlotFromApi(slot: MaintenanceSlot): MaintenanceSlot {
    return {
        ...slot,
        dayOfWeek: normalizeDayOfWeek(slot.dayOfWeek)
    };
}

function mapMaintenanceSlotToApi(slot: MaintenanceSlot) {
    return {
        ...slot,
        dayOfWeek: serializeDayOfWeek(slot.dayOfWeek),
        // Second line of defence for the D-07 CHECK: a reduced capacity left over from a switch back to
        // FullyBlocking would be rejected by the database as an opaque 500 instead of a translated 400.
        reducedCapacity: slot.blockingMode === BlockingMode.PartiallyBlocking ? slot.reducedCapacity : null
    };
}

export async function saveMaintenanceSlots(data: ResourceMaintenanceSlot): Promise<ErrorMessage | void> {
    try {
        // The endpoint answers 201 with an empty body on success — there is nothing to return.
        await api.post(
            baseUrlWithResource.replace('{resourceId}', data.resourceId),
            data.slots.map(mapMaintenanceSlotToApi)
        )
    } catch (error: any) {
        if (error?.response?.status === 400) {
            return {
                errorCode: error.response.data.errorCode,
                message: error.response.data.message,
                conflicts: error.response.data.conflicts ?? []
            }
        }

        throw error
    }
}

export async function getMaintenanceSlots(resourceId: string): Promise<ResourceMaintenanceSlot> {
    const res = await api.get(baseUrlWithResource.replace('{resourceId}', resourceId))
    const slots: ResourceMaintenanceSlot = {
        resourceId: resourceId,
        slots: res.data.items.map(mapMaintenanceSlotFromApi)
    }
    return slots
}

export async function getMaintenanceTimeSpans(from: string, to: string, resourceId?: string): Promise<MaintenanceTimeSpan[]> {
    const url = resourceId ? baseUrlWithResource.replace('{resourceId}', resourceId) : baseUrl;
    const res = await api.get(`${url}/timespans`, {
        params: { from, to }
    })
    return res.data
}
